import React from 'react';
import api from 'api';
import { AlertMessage, Spinner, Modal, NumberInput, TextInput, CodeEditor, DropdownSelector } from 'hyperdb-utils';
import settingsList from '../global-settings';

class Listing extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSaveSetting = this.handleSaveSetting.bind(this);
    this.closeModalSetting = this.closeModalSetting.bind(this);
  }
  componentWillUnmount() {
    this.props.api.globalSettings.setData({ showModalForm: false, editedSetting: null });
  }
  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row form-inline">
            <div className="col-md-4">
              <h3 className="box-title">Global settings</h3>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          {
            this.props.successMessage
              ? <AlertMessage
                  type="success"
                  onDismiss={ this.props.api.globalSettings.dismissAlert }>
                    { this.props.successMessage }
                </AlertMessage>
              : null
          }
          {
            this.props.errorMessage
              ? <AlertMessage
                  type="error"
                  onDismiss={ this.props.api.globalSettings.dismissAlert }>
                    { this.props.errorMessage }
                </AlertMessage>
              : null
          }
          <div className="box box-primary">
            <div className="box-body row">
              <div className="col-xs-12">
                <div className="table-responsive no-padding">
                  <table className="table table-hover table-striped table-bordered table-responsive">
                    <thead>
                      <tr>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        settingsList.map((setting, i) => {
                          return (
                            <tr key={i} style={{ cursor: 'pointer' }}>
                              <td onClick={ this.handleClickEdit.bind(this, setting) }>{ setting.name }</td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
        {
          this.props.showModalForm
            ? <Modal title={ `Edit setting ${this.props.editedSetting.name || ''}` } onClose={ this.closeModalSetting } onAccept={ this.handleSaveSetting } loading={ this.props.loading }>
                <Spinner show={ this.props.loading } />
                <fieldset>
                  { this.renderForm(this.props.editedSetting) }
                </fieldset>
              </Modal>
            : null
        }
      </div>
    );
  }

  renderForm(editedSetting) {
    let Component;
    switch (editedSetting.type) {
    case 'number':
      Component = NumberInput;
      break;
    case 'text':
      Component = TextInput;
      break;
    case 'json':
      Component = CodeEditor;
      break;
    case 'currency':
      Component = DropdownSelector;
      break;
    default:
      Component = null;
    }
    if (!Component) return null;
    const props = { label: 'Value', value: editedSetting.value, onChange: this.handleChange };
    if (editedSetting.type === 'json') props.mode = 'javascript';
    if (editedSetting.type === 'currency') props.options = ['EUR', 'USD'].map(o => ({ name: o, value: o}));
    return <Component { ...props } />;
  }

  handleClickEdit(setting) {
    this.props.api.globalSettings.setData({ showModalForm: true, editedSetting: {} });
    return this.props.api.globalSettings.getData({
      url: `/${setting.name}?type=${setting.type}`
    })
    .then(existingSetting => {
      if (!existingSetting) {
        this.props.api.globalSettings.setData({ showModalForm: true, editedSetting: { ...setting, value: '' } });
      } else {
        this.props.api.globalSettings.setData({ showModalForm: true, editedSetting: { ...existingSetting, type: setting.type } });
      }
    });
  }
  closeModalSetting() {
    this.props.api.globalSettings.setData({ showModalForm: false, editedSetting: null });
  }
  handleChange(field) {
    const editedSetting = { ...this.props.editedSetting, value: field.value };
    this.props.api.globalSettings.setData({ editedSetting });
  }
  handleSaveSetting() {
    const { name, value } = this.props.editedSetting;
    const data = this.props.editedSetting.type === 'json' ? value : { $val: value };
    this.props.api.globalSettings.postData({
      url: `/${name}`,
      data,
    })
    .then(() => {
      if (this.props.postDataSuccessful) {
        this.props.api.globalSettings.setData({ successMessage: 'Setting updated'});
        this.closeModalSetting();
      }
    });
  }
}

export default api.connect(Listing, 'globalSettings');



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/global/containers/Listing.jsx